import { Wrench, BarChart3, Monitor, Zap, Bot, Network, Radar, BookOpen, Code2, Settings, FolderOpen, Cpu, Sprout, TrendingUp, Trophy } from 'lucide-react';
import { ytId } from '../course-editor/content/meta';
import { stripHtml } from '../../lib/richText';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const FALLBACK_COVER = 'https://images.pexels.com/photos/8438967/pexels-photo-8438967.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600';

export const ARTICLES_HERO_IMG = 'https://static.prod-images.emergentagent.com/jobs/2f8d28b7-4ebe-4317-8ba5-2c9c19007ec7/images/fb6718fed088e6e4a953d50867b3bfcd0a28eb2e31a965daf1902cb64132ce89.jpeg';
const IMG = 'https://static.prod-images.emergentagent.com/jobs/2f8d28b7-4ebe-4317-8ba5-2c9c19007ec7/images/';
export const VIDEOS_HERO_IMG = `${IMG}98622ae7ece8441a2a59710b6ef83f81674ae9ca6ba924a0dafb62021731d742.jpeg`;
export const QUIZZES_HERO_IMG = `${IMG}8fd106d1a5e342a51e8c151c566ffcd75ed35af540ed2e168998430741b43a72.jpeg`;
export const LIB_IMGS = {
  articles: `${IMG}c448fc55842e03c802ab8c5989cda1af6716ae3539b902658a40593ed52d6c74.jpeg`,
  videos: `${IMG}7402283618c4b52de62e863313e2b370fdb95c94adf22aa6c456078cb4321b81.jpeg`,
  quizzes: `${IMG}e6741e26bba322c757cdf7a2faf164a24a27b71ae3d09e440b7bd8be137211b6.jpeg`,
};

export const normalizeVideo = (v) => {
  const url = v.url && v.url.startsWith('/api/') ? `${BACKEND_URL}${v.url}` : (v.url || '');
  const yt = ytId(v.youtube || '');
  return {
    id: v.id,
    title: { ar: v.titleAr, en: v.titleEn },
    excerpt: { ar: v.descAr, en: v.descEn },
    categories: Array.isArray(v.categories) && v.categories.length ? v.categories : [v.category || 'general'],
    url,
    youtubeId: yt,
    poster: yt ? `https://img.youtube.com/vi/${yt}/hqdefault.jpg` : posterFor(url),
    date: (v.created_at || '').slice(0, 10),
    is_free: !!v.is_free,
    views: v.views || 0,
    created: v.created_at || '',
  };
};

export const CAT_ICONS = {
  plc: Wrench, scada: BarChart3, hmi: Monitor, drives: Zap, robotics: Bot, networks: Network,
  sensors: Radar, general: BookOpen, programming: Code2, maintenance: Settings, projects: FolderOpen, devices: Cpu,
  beginner: Sprout, intermediate: TrendingUp, advanced: Trophy,
};

export const CAT_COLORS = [
  { tile: 'bg-blue-50 text-blue-600', pill: 'bg-blue-600 text-white' },
  { tile: 'bg-emerald-50 text-emerald-600', pill: 'bg-emerald-500 text-white' },
  { tile: 'bg-orange-50 text-orange-500', pill: 'bg-orange-500 text-white' },
  { tile: 'bg-violet-50 text-violet-600', pill: 'bg-violet-500 text-white' },
  { tile: 'bg-rose-50 text-rose-500', pill: 'bg-rose-500 text-white' },
  { tile: 'bg-amber-50 text-amber-500', pill: 'bg-amber-400 text-slate-900' },
  { tile: 'bg-sky-50 text-sky-600', pill: 'bg-sky-500 text-white' },
  { tile: 'bg-teal-50 text-teal-600', pill: 'bg-teal-500 text-white' },
];

export const colorFor = (categories, slug) => {
  const i = Math.max(0, categories.findIndex(c => c.value === slug));
  return CAT_COLORS[i % CAT_COLORS.length];
};

export const isVideoUrl = (u) => !!u && (u.includes('/video/upload/') || u.includes('/api/uploads/videos/') || /\.(mp4|mov|webm|m4v|ogg)(\?|$)/i.test(u));

export const posterFor = (u) => (u && u.includes('/video/upload/') ? u.replace(/\.(mp4|mov|webm|m4v|ogg)$/i, '.jpg') : null);

export const formatViews = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1).replace(/\.0$/, '')}K` : String(n || 0));

export const normalizeApiPost = (x) => ({
  id: x.id,
  title: { ar: x.titleAr, en: x.titleEn },
  excerpt: { ar: stripHtml(x.excerptAr || x.contentAr), en: stripHtml(x.excerptEn || x.contentEn) },
  categories: Array.isArray(x.categories) && x.categories.length ? x.categories : [x.category || 'general'],
  cover: x.cover ? (x.cover.startsWith('/api/') ? `${BACKEND_URL}${x.cover}` : x.cover) : FALLBACK_COVER,
  date: (x.created_at || '').slice(0, 10),
  is_free: !!x.is_free,
  views: x.views || 0,
  created: x.created_at || '',
  readMinutes: x.read_minutes || 1,
});

export const normalizeMockPost = (x) => ({ ...x, categories: ['general'], is_free: false, views: 0, readMinutes: 5 });
